import React from 'react';
import { style } from 'typestyle';
import { Link } from '@src/components/Link';
import { ADALONG_COLORS } from '@src/styles';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={footerClass}>
      <div className={footerContentClass}>
        <Link 
          className={linkClass} 
          href="https://www.adalong.com/privacy/" 
          target="_blank" 
          rel="noreferrer"
        >
          Privacy Policy
        </Link>
        <span className={separatorClass}>•</span>
        <Link 
          className={linkClass} 
          href="https://www.adalong.com/terms-of-use/" 
          target="_blank" 
          rel="noreferrer"
        >
          Terms of Service
        </Link>
        <span className={separatorClass}>•</span>
        <span className={copyrightClass}>
          © {currentYear} - Adalong
        </span>
      </div>
    </footer>
  );
}

const footerClass = style({
  backgroundColor: ADALONG_COLORS.DARK_BLACK,
  padding: '8px 0',
  flexShrink: 0,
});

const footerContentClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 20px',
});

const linkClass = style({
  color: ADALONG_COLORS.LIGHT_GRAY,
  fontSize: '12px',
  textDecoration: 'none',
  $nest: {
    '&:hover': {
      color: 'white',
      textDecoration: 'underline',
    },
  },
});

const separatorClass = style({
  color: ADALONG_COLORS.LIGHT_GRAY,
  fontSize: '12px',
});

const copyrightClass = style({
  color: ADALONG_COLORS.LIGHT_GRAY,
  fontSize: '12px',
});
